/**
 * usePageReadyForTour
 * Hook to determine when the page is ready to start a tour
 * Combines page load state and PWA prompt visibility checks
 */

import { usePWAPromptVisible } from '@shared/contexts'
import { useEffect, useState } from 'react'

export function usePageReadyForTour(): boolean {
  const [isPageLoaded, setIsPageLoaded] = useState(false)
  const isPWAPromptVisible = usePWAPromptVisible()

  useEffect(() => {
    // Check if page is already loaded
    if (document.readyState === 'complete') {
      setIsPageLoaded(true)
      return
    }

    // Listen for page load
    const handleLoad = () => {
      setIsPageLoaded(true)
    }

    window.addEventListener('load', handleLoad)
    return () => window.removeEventListener('load', handleLoad)
  }, [])

  // Page is ready for tour if:
  // 1. Page has finished loading AND
  // 2. PWA prompt is NOT visible
  return isPageLoaded && !isPWAPromptVisible
}
